import Vue from 'vue';
import { getRoute } from '../services/utility';

Vue.filter('profile-image', function (value) {
    return getRoute(value, '/image/profile/');
});

Vue.filter('conversation-image', function (value) {
    return getRoute(value);
});

Vue.filter('googleInfoClean', function (value) {
    return value.replace('Province', '');
});

Vue.filter('numberFormatter', function (value) {
    if (!value) {
        return '';
    } else {
        let strNumber = value.toString();
        let numberParts = strNumber.split('.');
        let decimalPart = '';
        if (numberParts[1]) {
            decimalPart = ',' + numberParts[1].substr(0, 2);
        }
        return numberParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + decimalPart;
    }
});

Vue.filter('distanceConverter', function (value, system) {
    if (!system) {
        return value;
    } else {
        return (value * 0.6214);
    }
});

Vue.filter('distanceFormatter', function (value, system, unit) {
    if (!system) {
        if (unit === 'big') {
            return value > 1 ? value.toFixed(2) + ' Kms' : value.toFixed(2) + ' Km';
        } else {
            return value > 1 ? (value * 1000).toFixed(0) + ' mts' : (value * 1000).toFixed(0) + ' mt';
        }
    } else {
        if (unit === 'big') {
            return value.toFixed(2) + ' mi';
        } else {
            return (value * 5280).toFixed(0) + ' ft';
        }
    }
});

Vue.filter('hideLicense', function (license) {
    let len = license.length;
    return license.slice(0, 2) + '*'.repeat(len - 4) + license.slice(len - 2, len);
});



// WEBPACK FOOTER //
// ./src/components/filters.js